<template>
    <el-dialog class="peiso-modal" 
    :visible.sync="isOpen"
    :modal-append-to-body="false"
    :close-on-click-modal='true'
    :close-on-press-escape="true"
    width="600px"
    :before-close="handleClose"
    center>

        <div>
            <div class="header-container confirm-heade-container">
                <span v-html="isLabel">
                     
                </span>
            </div>

            <div class="body-transaction d-flex justify-content-center gap-16 m-top-1-5rem">
                <el-button type="peiso-white-border-only" class="px-2rem" @click="handleClose">Cancel</el-button>
                <el-button type="peiso-primary-pink-border-only" v-if="!loading" class="px-2rem" @click="generate">Generate</el-button>
                <el-button type="peiso-primary-pink-border-only" v-if="loading" class="px-2rem"><i class="el-icon-loading"></i> Generating...</el-button>

            </div>
        </div>

    </el-dialog>
</template>

<style lang='scss'>
@import '../../../static/scss/colors.scss';
@import '../../../static/scss/fonts/fonts.scss';
    .confirm-heade-container {
        text-align: center;
        margin-bottom: 3rem !important;
        span {
            list-style: 40px !important;
        }
    }
    .transaction-selector {
        
        .feature-container {
            @include montserrat-font(15px, 150%, 600, $white) {
                letter-spacing: 0.2px;
                gap: 1rem;
                border-radius: 5px;
                border: 1px solid $gray6;
                position: relative;
                height: 150px;
                transition: 0.3s;
            }

            &:hover {
                background-color: var(--primary-color);
            }
            
        }
    }
</style>

<script>
    import api from "@/api/dashboard";
    import utils from '@/utils/utils'
    export default {
        data() {
            return {
                isOpen: false,
                loading: false
            }
        },

        props: {
            open: {
                default: false,
            },
            isType: {
                default: 1
            },
            isLabel: {
                default: ''
            }
        },
        watch: {
            open(val) {
                this.isOpen = val
   
            }
        },
        methods: {
            handleClose() {
                this.isOpen = false
                this.$emit('close-modal')
            },

            generate() {
                this.loading = true
                try {
                    if (this.isType == 1) {
                        api.runEodWeeklyReport().then((res) => {
                            this.loading = false
                            if (res.data.code == 0) {
                                utils.alert2('', 'Successfully generated.', 'success')
                            
                            } else {
                                utils.alert2('', `Error ${res.data.code} - ${res.data.message}, Please contact system administrator`, 'error')
                            }
                            this.handleClose()
                            this.$emit('close-modal')
                        });
                    } else if (this.isType == 2) {
                        api.runCashupEndofWeek().then((res) => {
                            this.loading = false
                            if (res.data.code == 0) {
                                utils.alert2('', 'Successfully generated.', 'success')
                            
                            } else {
                                utils.alert2('', `Error ${res.data.code} - ${res.data.message}, Please contact system administrator`, 'error') 
                            }
                            this.handleClose()
                            this.$emit('close-modal')
                        });
                    }
                } catch (error) {
                    console.log('error: ', error);
                    utils.alert2('', 'Something went wrong please try again.', 'error')
                }
    
            },

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modal/confirmWeeklyReport.vue